import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    // still checking auth
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center bg-[#050505] text-[#A19E9C]"
      >
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-[#C5A059] animate-pulse" />
          <span className="text-xs uppercase tracking-[0.3em]">Loading…</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate to="/admin/login" state={{ from: location.pathname }} replace />
    );
  }

  return children;
};

export default ProtectedRoute;
